import FileItem from "pages/Material/view/components/FileItem";

import type {MaterialFileItem as MaterialFileItemType} from "../types";

const MaterialFileItem = ({item}: { item: MaterialFileItemType }) => (
  <FileItem
    name={item.name}
    file={item.file}
    padding={0}
    backgroundColor="transparent"
  />
);

export default MaterialFileItem;
